var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16669 1.66675C5.02455 1.66675 1.66669 5.02461 1.66669 9.16675C1.66669 13.3089 5.02455 16.6667 9.16669 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0267L16.9108 18.0893C17.2362 18.4148 17.7638 18.4148 18.0893 18.0893C18.4147 17.7639 18.4147 17.2363 18.0893 16.9108L15.0266 13.8482C16.053 12.5651 16.6667 10.9376 16.6667 9.16675C16.6667 5.02461 13.3088 1.66675 9.16669 1.66675ZM3.33335 9.16675C3.33335 5.94509 5.94503 3.33341 9.16669 3.33341C12.3883 3.33341 15 5.94509 15 9.16675C15 12.3884 12.3883 15.0001 9.16669 15.0001C5.94503 15.0001 3.33335 12.3884 3.33335 9.16675Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1c7238b889e053244a9b1792df3f6440.svg";
export { ForwardRef as ReactComponent };